/**
 * Generated by orval v7.1.1 🍺
 * Do not edit manually.
 * AOS App API
 * AOS App API
 * OpenAPI spec version: 1.0.0
 */
import axios from 'axios'
import type {
  AxiosError,
  AxiosRequestConfig,
  AxiosResponse
} from 'axios'
import useSwr from 'swr'
import type {
  Arguments,
  Key,
  SWRConfiguration
} from 'swr'
import useSWRMutation from 'swr/mutation'
import type {
  SWRMutationConfiguration
} from 'swr/mutation'
import {
  faker
} from '@faker-js/faker'
import {
  HttpResponse,
  delay,
  http
} from 'msw'

// https://stackoverflow.com/questions/49579094/typescript-conditional-types-filter-out-readonly-properties-pick-only-requir/49579497#49579497
type IfEquals<X, Y, A = X, B = never> = (<T>() => T extends X ? 1 : 2) extends <
T,
>() => T extends Y ? 1 : 2
? A
: B;

type WritableKeys<T> = {
[P in keyof T]-?: IfEquals<
  { [Q in P]: T[P] },
  { -readonly [Q in P]: T[P] },
  P
>;
}[keyof T];

type UnionToIntersection<U> =
  (U extends any ? (k: U)=>void : never) extends ((k: infer I)=>void) ? I : never;
type DistributeReadOnlyOverUnions<T> = T extends any ? NonReadonly<T> : never;

type Writable<T> = Pick<T, WritableKeys<T>>;
type NonReadonly<T> = [T] extends [UnionToIntersection<T>] ? {
  [P in keyof Writable<T>]: T[P] extends object
    ? NonReadonly<NonNullable<T[P]>>
    : T[P];
} : DistributeReadOnlyOverUnions<T>;

export type CreateMeetingBody = {
  device_id: string;
};

export type ListReceptionCallHistories200Meta = {
  count?: number;
  num_page?: number;
  page?: number;
  page_size?: number;
};

export type ListReceptionCallHistories200 = {
  meta?: ListReceptionCallHistories200Meta;
  results?: ReceptionCallHistory[];
};

export type ListReceptionCallHistoriesReceiverStatus = typeof ListReceptionCallHistoriesReceiverStatus[keyof typeof ListReceptionCallHistoriesReceiverStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ListReceptionCallHistoriesReceiverStatus = {
  NUMBER_0: 0,
  NUMBER_1: 1,
  NUMBER_2: 2,
  NUMBER_3: 3,
  NUMBER_4: 4,
} as const;

export type ListReceptionCallHistoriesParams = {
/**
 * A page number within the paginated result set.
 */
page?: number;
/**
 * Number of results to return per page.
 */
page_size?: number;
/**
 * created
 */
created?: string;
/**
 * device
 */
device?: string;
/**
 * receiver_status
 */
receiver_status?: ListReceptionCallHistoriesReceiverStatus;
/**
 * date_after
 */
date_after?: string;
/**
 * date_before
 */
date_before?: string;
/**
 * missed_call
 */
missed_call?: string;
};

export type SignInBody = {
  password?: string;
  username?: string;
};

export interface UserProfileResponse {
  language?: string;
  name?: string;
  timezone?: string;
  username?: string;
}

export interface MeetingResponse {
  Attendees: MeetingResponseAttendeesItem[];
  Errors: MeetingResponseErrorsItem[];
  Meeting: MeetingResponseMeeting;
}

export type MeetingResponseMeetingMeetingFeaturesVideo = {
  MaxResolution: string;
};

export type MeetingResponseMeetingMeetingFeaturesContent = {
  MaxResolution: string;
};

export type MeetingResponseMeetingMeetingFeaturesAudio = {
  EchoReduction: string;
};

export type MeetingResponseMeetingMeetingFeaturesAttendee = {
  MaxCount: number;
};

/**
 * @nullable
 */
export type MeetingResponseMeetingMeetingFeatures = {
  Attendee: MeetingResponseMeetingMeetingFeaturesAttendee;
  Audio: MeetingResponseMeetingMeetingFeaturesAudio;
  Content: MeetingResponseMeetingMeetingFeaturesContent;
  Video: MeetingResponseMeetingMeetingFeaturesVideo;
} | null;

export type MeetingResponseMeetingMediaPlacement = {
  AudioFallbackUrl: string;
  AudioHostUrl: string;
  EventIngestionUrl: string;
  ScreenDataUrl: string;
  ScreenSharingUrl: string;
  ScreenViewingUrl: string;
  SignalingUrl: string;
  TurnControlUrl: string;
};

export type MeetingResponseMeeting = {
  ExternalMeetingId: string;
  MediaPlacement: MeetingResponseMeetingMediaPlacement;
  MediaRegion: string;
  MeetingArn: string;
  /** @nullable */
  MeetingFeatures?: MeetingResponseMeetingMeetingFeatures;
  /** @nullable */
  MeetingHostId?: string | null;
  MeetingId: string;
  /** @nullable */
  PrimaryMeetingId?: string | null;
  TenantIds: string[];
};

export type MeetingResponseErrorsItem = {
  ErrorCode: string;
  ErrorMessage: string;
  ExternalUserId: string;
};

export type MeetingResponseAttendeesItemCapabilities = {
  Audio: string;
  Content: string;
  Video: string;
};

export type MeetingResponseAttendeesItem = {
  AttendeeId: string;
  Capabilities: MeetingResponseAttendeesItemCapabilities;
  ExternalUserId: string;
  JoinToken: string;
};

export type ReceptionCallHistoryTranslationsPropertyTranslationsJa = {
  name?: string;
};

export type ReceptionCallHistoryTranslationsPropertyTranslationsEn = {
  name?: string;
};

export type ReceptionCallHistoryTranslationsPropertyTranslations = {
  readonly en?: ReceptionCallHistoryTranslationsPropertyTranslationsEn;
  readonly ja?: ReceptionCallHistoryTranslationsPropertyTranslationsJa;
};

export type ReceptionCallHistoryTranslationsDeviceTranslationsJa = {
  description?: string;
  name?: string;
};

export type ReceptionCallHistoryTranslationsDeviceTranslationsEn = {
  description?: string;
  name?: string;
};

export type ReceptionCallHistoryTranslationsDeviceTranslations = {
  readonly en?: ReceptionCallHistoryTranslationsDeviceTranslationsEn;
  readonly ja?: ReceptionCallHistoryTranslationsDeviceTranslationsJa;
};

export type ReceptionCallHistoryTranslations = {
  readonly device_translations?: ReceptionCallHistoryTranslationsDeviceTranslations;
  readonly property_translations?: ReceptionCallHistoryTranslationsPropertyTranslations;
};

/**
 * @nullable
 */
export type ReceptionCallHistoryReceiverStatus = typeof ReceptionCallHistoryReceiverStatus[keyof typeof ReceptionCallHistoryReceiverStatus] | null;


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReceptionCallHistoryReceiverStatus = {
  NUMBER_0: 0,
  NUMBER_1: 1,
  NUMBER_2: 2,
  NUMBER_3: 3,
  NUMBER_4: 4,
  NUMBER_5: 5,
} as const;

/**
 * @nullable
 */
export type ReceptionCallHistoryCallerStatus = typeof ReceptionCallHistoryCallerStatus[keyof typeof ReceptionCallHistoryCallerStatus] | null;


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReceptionCallHistoryCallerStatus = {
  NUMBER_0: 0,
  NUMBER_1: 1,
  NUMBER_2: 2,
  NUMBER_3: 3,
  NUMBER_4: 4,
  NUMBER_5: 5,
} as const;

export type ReceptionCallHistoryCallType = typeof ReceptionCallHistoryCallType[keyof typeof ReceptionCallHistoryCallType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReceptionCallHistoryCallType = {
  call_from_device: 'call_from_device',
  redial_from_reception: 'redial_from_reception',
} as const;

export interface ReceptionCallHistory {
  readonly call_type?: ReceptionCallHistoryCallType;
  /** @nullable */
  caller_status?: ReceptionCallHistoryCallerStatus;
  canceled?: string;
  readonly created?: string;
  finished?: string;
  readonly meeting_id?: string;
  /** @pattern ^[-a-zA-Z0-9_]+$ */
  readonly organization_slug?: string;
  /** @pattern ^[-a-zA-Z0-9_]+$ */
  readonly property_slug?: string;
  received?: string;
  readonly received_user?: string;
  /** @nullable */
  receiver_status?: ReceptionCallHistoryReceiverStatus;
  readonly reception_device_id?: string;
  rejected?: string;
  readonly task_sid?: string;
  timeouted?: string;
  readonly translations?: ReceptionCallHistoryTranslations;
}

export interface TwilioTokenResponse {
  twilio_access_token?: string;
  twilio_worker_sid?: string;
}

export interface SignInResponse {
  expiry?: string;
  token?: string;
}




  type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


  export const signIn = (
    signInBody: SignInBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<SignInResponse>> => {
    return axios.post(
      `https://app.suitebook.cloud/api/accounts/sign-in/`,
      signInBody,options
    );
  }



export const getSignInMutationFetcher = ( options?: AxiosRequestConfig) => {
  return (_: Key, { arg }: { arg: SignInBody }): Promise<AxiosResponse<SignInResponse>> => {
    return signIn(arg, options);
  }
}
export const getSignInMutationKey = () => [`https://app.suitebook.cloud/api/accounts/sign-in/`] as const;

export type SignInMutationResult = NonNullable<Awaited<ReturnType<typeof signIn>>>
export type SignInMutationError = AxiosError<unknown>

export const useSignIn = <TError = AxiosError<unknown>>(
   options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof signIn>>, TError, Key, SignInBody, Awaited<ReturnType<typeof signIn>>> & { swrKey?: string }, axios?: AxiosRequestConfig}
) => {

  const {swr: swrOptions, axios: axiosOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getSignInMutationKey();
  const swrFn = getSignInMutationFetcher(axiosOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export const twilioToken = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<TwilioTokenResponse>> => {
    return axios.post(
      `https://app.suitebook.cloud/api/accounts/user/twilio-access-token/`,undefined,options
    );
  }



export const getTwilioTokenMutationFetcher = ( options?: AxiosRequestConfig) => {
  return (_: Key, __: { arg: Arguments }): Promise<AxiosResponse<TwilioTokenResponse>> => {
    return twilioToken(options);
  }
}
export const getTwilioTokenMutationKey = () => [`https://app.suitebook.cloud/api/accounts/user/twilio-access-token/`] as const;

export type TwilioTokenMutationResult = NonNullable<Awaited<ReturnType<typeof twilioToken>>>
export type TwilioTokenMutationError = AxiosError<unknown>

export const useTwilioToken = <TError = AxiosError<unknown>>(
   options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof twilioToken>>, TError, Key, Arguments, Awaited<ReturnType<typeof twilioToken>>> & { swrKey?: string }, axios?: AxiosRequestConfig}
) => {

  const {swr: swrOptions, axios: axiosOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getTwilioTokenMutationKey();
  const swrFn = getTwilioTokenMutationFetcher(axiosOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export const listReceptionCallHistories = (
    params?: ListReceptionCallHistoriesParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ListReceptionCallHistories200>> => {
    return axios.get(
      `https://app.suitebook.cloud/api/accounts/receptions/histories/`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getListReceptionCallHistoriesKey = (params?: ListReceptionCallHistoriesParams,) => [`https://app.suitebook.cloud/api/accounts/receptions/histories/`, ...(params ? [params]: [])] as const;

export type ListReceptionCallHistoriesQueryResult = NonNullable<Awaited<ReturnType<typeof listReceptionCallHistories>>>
export type ListReceptionCallHistoriesQueryError = AxiosError<unknown>

export const useListReceptionCallHistories = <TError = AxiosError<unknown>>(
  params?: ListReceptionCallHistoriesParams, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof listReceptionCallHistories>>, TError> & { swrKey?: Key, enabled?: boolean }, axios?: AxiosRequestConfig }
) => {
  const {swr: swrOptions, axios: axiosOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getListReceptionCallHistoriesKey(params) : null);
  const swrFn = () => listReceptionCallHistories(params, axiosOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export const getUserProfile = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<UserProfileResponse>> => {
    return axios.get(
      `https://app.suitebook.cloud/api/accounts/user/`,options
    );
  }



export const getGetUserProfileKey = () => [`https://app.suitebook.cloud/api/accounts/user/`] as const;

export type GetUserProfileQueryResult = NonNullable<Awaited<ReturnType<typeof getUserProfile>>>
export type GetUserProfileQueryError = AxiosError<unknown>

export const useGetUserProfile = <TError = AxiosError<unknown>>(
   options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getUserProfile>>, TError> & { swrKey?: Key, enabled?: boolean }, axios?: AxiosRequestConfig }
) => {
  const {swr: swrOptions, axios: axiosOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetUserProfileKey() : null);
  const swrFn = () => getUserProfile(axiosOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export const createMeeting = (
    createMeetingBody: CreateMeetingBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<MeetingResponse>> => {
    return axios.post(
      `https://app.suitebook.cloud/api/accounts/receptions/meeting/`,
      createMeetingBody,options
    );
  }



export const getCreateMeetingMutationFetcher = ( options?: AxiosRequestConfig) => {
  return (_: Key, { arg }: { arg: CreateMeetingBody }): Promise<AxiosResponse<MeetingResponse>> => {
    return createMeeting(arg, options);
  }
}
export const getCreateMeetingMutationKey = () => [`https://app.suitebook.cloud/api/accounts/receptions/meeting/`] as const;

export type CreateMeetingMutationResult = NonNullable<Awaited<ReturnType<typeof createMeeting>>>
export type CreateMeetingMutationError = AxiosError<unknown>

export const useCreateMeeting = <TError = AxiosError<unknown>>(
   options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof createMeeting>>, TError, Key, CreateMeetingBody, Awaited<ReturnType<typeof createMeeting>>> & { swrKey?: string }, axios?: AxiosRequestConfig}
) => {

  const {swr: swrOptions, axios: axiosOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getCreateMeetingMutationKey();
  const swrFn = getCreateMeetingMutationFetcher(axiosOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export const patchReceptionCallHistory = (
    meetingId: string,
    receptionCallHistory: NonReadonly<ReceptionCallHistory>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ReceptionCallHistory>> => {
    return axios.patch(
      `https://app.suitebook.cloud/api/accounts/receptions/histories/meetings/${meetingId}/`,
      receptionCallHistory,options
    );
  }



export const getPatchReceptionCallHistoryMutationFetcher = (meetingId: string, options?: AxiosRequestConfig) => {
  return (_: Key, { arg }: { arg: NonReadonly<ReceptionCallHistory> }): Promise<AxiosResponse<ReceptionCallHistory>> => {
    return patchReceptionCallHistory(meetingId, arg, options);
  }
}
export const getPatchReceptionCallHistoryMutationKey = (meetingId: string,) => [`https://app.suitebook.cloud/api/accounts/receptions/histories/meetings/${meetingId}/`] as const;

export type PatchReceptionCallHistoryMutationResult = NonNullable<Awaited<ReturnType<typeof patchReceptionCallHistory>>>
export type PatchReceptionCallHistoryMutationError = AxiosError<unknown>

export const usePatchReceptionCallHistory = <TError = AxiosError<unknown>>(
  meetingId: string, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof patchReceptionCallHistory>>, TError, Key, NonReadonly<ReceptionCallHistory>, Awaited<ReturnType<typeof patchReceptionCallHistory>>> & { swrKey?: string }, axios?: AxiosRequestConfig}
) => {

  const {swr: swrOptions, axios: axiosOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPatchReceptionCallHistoryMutationKey(meetingId);
  const swrFn = getPatchReceptionCallHistoryMutationFetcher(meetingId, axiosOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}



export const getSignInResponseMock = (overrideResponse: Partial< SignInResponse > = {}): SignInResponse => ({expiry: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), token: faker.helpers.arrayElement([faker.word.sample(), undefined]), ...overrideResponse})

export const getTwilioTokenResponseMock = (overrideResponse: Partial< TwilioTokenResponse > = {}): TwilioTokenResponse => ({twilio_access_token: faker.helpers.arrayElement([faker.word.sample(), undefined]), twilio_worker_sid: faker.helpers.arrayElement([faker.word.sample(), undefined]), ...overrideResponse})

export const getListReceptionCallHistoriesResponseMock = (overrideResponse: Partial< ListReceptionCallHistories200 > = {}): ListReceptionCallHistories200 => ({meta: faker.helpers.arrayElement([{count: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), num_page: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), page: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), page_size: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined])}, undefined]), results: faker.helpers.arrayElement([Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({call_type: faker.helpers.arrayElement([faker.helpers.arrayElement(['call_from_device','redial_from_reception'] as const), undefined]), caller_status: faker.helpers.arrayElement([faker.helpers.arrayElement([1,2,3,4,5] as const), undefined]), canceled: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), created: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), finished: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), meeting_id: faker.helpers.arrayElement([faker.word.sample(), undefined]), organization_slug: faker.helpers.arrayElement([faker.helpers.fromRegExp('^[-a-zA-Z0-9_]+$'), undefined]), property_slug: faker.helpers.arrayElement([faker.helpers.fromRegExp('^[-a-zA-Z0-9_]+$'), undefined]), received: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), received_user: faker.helpers.arrayElement([faker.word.sample(), undefined]), receiver_status: faker.helpers.arrayElement([faker.helpers.arrayElement([1,2,3,4,5] as const), undefined]), reception_device_id: faker.helpers.arrayElement([faker.word.sample(), undefined]), rejected: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), task_sid: faker.helpers.arrayElement([faker.word.sample(), undefined]), timeouted: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), translations: faker.helpers.arrayElement([{device_translations: faker.helpers.arrayElement([{en: faker.helpers.arrayElement([{description: faker.helpers.arrayElement([faker.word.sample(), undefined]), name: faker.helpers.arrayElement([faker.word.sample(), undefined])}, undefined]), ja: faker.helpers.arrayElement([{description: faker.helpers.arrayElement([faker.word.sample(), undefined]), name: faker.helpers.arrayElement([faker.word.sample(), undefined])}, undefined])}, undefined]), property_translations: faker.helpers.arrayElement([{en: faker.helpers.arrayElement([{name: faker.helpers.arrayElement([faker.word.sample(), undefined])}, undefined]), ja: faker.helpers.arrayElement([{name: faker.helpers.arrayElement([faker.word.sample(), undefined])}, undefined])}, undefined])}, undefined])})), undefined]), ...overrideResponse})

export const getGetUserProfileResponseMock = (overrideResponse: Partial< UserProfileResponse > = {}): UserProfileResponse => ({language: faker.helpers.arrayElement([faker.word.sample(), undefined]), name: faker.helpers.arrayElement([faker.word.sample(), undefined]), timezone: faker.helpers.arrayElement([faker.word.sample(), undefined]), username: faker.helpers.arrayElement([faker.word.sample(), undefined]), ...overrideResponse})

export const getCreateMeetingResponseMock = (overrideResponse: Partial< MeetingResponse > = {}): MeetingResponse => ({Attendees: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({AttendeeId: faker.word.sample(), Capabilities: {Audio: faker.word.sample(), Content: faker.word.sample(), Video: faker.word.sample()}, ExternalUserId: faker.word.sample(), JoinToken: faker.word.sample()})), Errors: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({ErrorCode: faker.word.sample(), ErrorMessage: faker.word.sample(), ExternalUserId: faker.word.sample()})), Meeting: {ExternalMeetingId: faker.word.sample(), MediaPlacement: {AudioFallbackUrl: faker.word.sample(), AudioHostUrl: faker.word.sample(), EventIngestionUrl: faker.word.sample(), ScreenDataUrl: faker.word.sample(), ScreenSharingUrl: faker.word.sample(), ScreenViewingUrl: faker.word.sample(), SignalingUrl: faker.word.sample(), TurnControlUrl: faker.word.sample()}, MediaRegion: faker.word.sample(), MeetingArn: faker.word.sample(), MeetingFeatures: faker.helpers.arrayElement([{Attendee: {MaxCount: faker.number.int({min: undefined, max: undefined})}, Audio: {EchoReduction: faker.word.sample()}, Content: {MaxResolution: faker.word.sample()}, Video: {MaxResolution: faker.word.sample()}}, undefined]), MeetingHostId: faker.helpers.arrayElement([faker.helpers.arrayElement([faker.word.sample(), null]), undefined]), MeetingId: faker.word.sample(), PrimaryMeetingId: faker.helpers.arrayElement([faker.helpers.arrayElement([faker.word.sample(), null]), undefined]), TenantIds: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (faker.word.sample()))}, ...overrideResponse})

export const getPatchReceptionCallHistoryResponseMock = (overrideResponse: Partial< ReceptionCallHistory > = {}): ReceptionCallHistory => ({call_type: faker.helpers.arrayElement([faker.helpers.arrayElement(['call_from_device','redial_from_reception'] as const), undefined]), caller_status: faker.helpers.arrayElement([faker.helpers.arrayElement([1,2,3,4,5] as const), undefined]), canceled: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), created: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), finished: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), meeting_id: faker.helpers.arrayElement([faker.word.sample(), undefined]), organization_slug: faker.helpers.arrayElement([faker.helpers.fromRegExp('^[-a-zA-Z0-9_]+$'), undefined]), property_slug: faker.helpers.arrayElement([faker.helpers.fromRegExp('^[-a-zA-Z0-9_]+$'), undefined]), received: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), received_user: faker.helpers.arrayElement([faker.word.sample(), undefined]), receiver_status: faker.helpers.arrayElement([faker.helpers.arrayElement([1,2,3,4,5] as const), undefined]), reception_device_id: faker.helpers.arrayElement([faker.word.sample(), undefined]), rejected: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), task_sid: faker.helpers.arrayElement([faker.word.sample(), undefined]), timeouted: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), translations: faker.helpers.arrayElement([{device_translations: faker.helpers.arrayElement([{en: faker.helpers.arrayElement([{description: faker.helpers.arrayElement([faker.word.sample(), undefined]), name: faker.helpers.arrayElement([faker.word.sample(), undefined])}, undefined]), ja: faker.helpers.arrayElement([{description: faker.helpers.arrayElement([faker.word.sample(), undefined]), name: faker.helpers.arrayElement([faker.word.sample(), undefined])}, undefined])}, undefined]), property_translations: faker.helpers.arrayElement([{en: faker.helpers.arrayElement([{name: faker.helpers.arrayElement([faker.word.sample(), undefined])}, undefined]), ja: faker.helpers.arrayElement([{name: faker.helpers.arrayElement([faker.word.sample(), undefined])}, undefined])}, undefined])}, undefined]), ...overrideResponse})


export const getSignInMockHandler = (overrideResponse?: SignInResponse | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<SignInResponse> | SignInResponse)) => {
  return http.post('*/api/accounts/sign-in/', async (info) => {await delay(1000);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getSignInResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getTwilioTokenMockHandler = (overrideResponse?: TwilioTokenResponse | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<TwilioTokenResponse> | TwilioTokenResponse)) => {
  return http.post('*/api/accounts/user/twilio-access-token/', async (info) => {await delay(1000);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getTwilioTokenResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getListReceptionCallHistoriesMockHandler = (overrideResponse?: ListReceptionCallHistories200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<ListReceptionCallHistories200> | ListReceptionCallHistories200)) => {
  return http.get('*/api/accounts/receptions/histories/', async (info) => {await delay(1000);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getListReceptionCallHistoriesResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getGetUserProfileMockHandler = (overrideResponse?: UserProfileResponse | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<UserProfileResponse> | UserProfileResponse)) => {
  return http.get('*/api/accounts/user/', async (info) => {await delay(1000);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getGetUserProfileResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getCreateMeetingMockHandler = (overrideResponse?: MeetingResponse | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<MeetingResponse> | MeetingResponse)) => {
  return http.post('*/api/accounts/receptions/meeting/', async (info) => {await delay(1000);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getCreateMeetingResponseMock()),
      { status: 201,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPatchReceptionCallHistoryMockHandler = (overrideResponse?: ReceptionCallHistory | ((info: Parameters<Parameters<typeof http.patch>[1]>[0]) => Promise<ReceptionCallHistory> | ReceptionCallHistory)) => {
  return http.patch('*/api/accounts/receptions/histories/meetings/:meetingId/', async (info) => {await delay(1000);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPatchReceptionCallHistoryResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}
export const getAOSAppAPIMock = () => [
  getSignInMockHandler(),
  getTwilioTokenMockHandler(),
  getListReceptionCallHistoriesMockHandler(),
  getGetUserProfileMockHandler(),
  getCreateMeetingMockHandler(),
  getPatchReceptionCallHistoryMockHandler()
]
